export default __webpack_public_path__ + "static/media/bopifyPlaylistIcon.ebaa5928.jpg";